<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
};
</script>
<style lang="scss">
html,
body {
  // background-color: #09193A;
}


/* 全局滚动条样式 */
// *::-webkit-scrollbar {
//   width: 8px;
//   height: 8px;
// }

// *::-webkit-scrollbar-track {
//   background-color: #09193a85;
//   border-radius: 4px;
// }

// *::-webkit-scrollbar-thumb {
//   background-color: #0d275c;
//   border-radius: 4px;
// }

// *::-webkit-scrollbar-button {
//   background-color: #09193a85;
// }


</style>
